import { trackConfig, type IFramework } from '@/framework';
import { LayerType, TextAlignType, type ILayerProps, type ITextLayerProps } from '@/version-types';
import { pushHistory, updateGroupLayer, updateLayer, validateInputLayer } from '../utils';

export interface IAlignment {
    /**
     * 设置水平对齐方式
     * @param layerID - 图层 id
     * @param align - 对齐方式
     * @returns
     */
    setTextAlign(layerID: string, align: TextAlignType): void;
}

export class Alignment implements IAlignment {
    constructor(private framework: IFramework) {}

    private set(
        prevLayer: ILayerProps,
        value: TextAlignType,
        options: { update?: boolean; writeHistory?: boolean } = {},
    ) {
        const { update = false, writeHistory = false } = options;

        const prevLayerData = prevLayer.data as ITextLayerProps;

        const { shapeExtension } = prevLayerData;
        if (shapeExtension) return;

        const nextLayerData: ITextLayerProps = { ...prevLayerData, textAlign: value };
        const nextLayer: ILayerProps = { ...prevLayer, data: nextLayerData };

        updateLayer(this.framework, nextLayer);
        if (writeHistory)
            pushHistory(this.framework, prevLayer, nextLayer, trackConfig[LayerType.TEXT_LAYER].textAlign);

        return nextLayer;
    }

    setTextAlign(layerID: string, value: TextAlignType) {
        const prevLayer = this.framework.getLayer(layerID, true);
        if (!validateInputLayer(prevLayer)) return;

        if (prevLayer.layerType === LayerType.GROUP_LAYER) {
            const children = prevLayer.children;
            if (children.length === 0) return;

            const layers = children.map((child) => this.set(child, value)).filter(Boolean) as ILayerProps[];
            const nextLayer = updateGroupLayer(this.framework, prevLayer, layers, {
                funcID: trackConfig[LayerType.TEXT_LAYER].textAlign,
                update: true,
                writeHistory: true,
            });

            return nextLayer;
        }

        return this.set(prevLayer, value, { update: true, writeHistory: true });
    }
}
